export default __webpack_public_path__ + "static/media/food.d64a6b92.svg";